<template>
  <div class="custom-order">
    <Breadcrumb></Breadcrumb>

    <!-- 过滤条件 -->
    <div class="form-body">
      <el-form :model="form" ref="form" label-width="80px">
        <el-row v-if="user.userType != '00'" :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="店铺名称：" class="item">
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    placeholder="店铺名称"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >

                  <el-checkbox-group
                    filterable
                    v-model="form.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="
                        (isExpand || index < 10) &&
                        item.shopName.indexOf(shopName) > -1
                      "
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpand = !isExpand"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #409eff;
                    float: left;
                  "
                >
                  {{ isExpand ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="订单状态：" class="item">
                <el-checkbox
                  @change="handleChangeStatus"
                  v-model="isCheckStatus"
                  >全选</el-checkbox
                >
                <el-checkbox-group
                  clearable
                  v-model="form.amazonOrderStatus"
                  placeholder="请选择订单状态"
                  class="input"
                  size="small"
                  style="display: inline; margin: 0 0 0 27px"
                >
                  <el-checkbox
                    v-for="value in dictData['amazon_order_status']"
                    :key="value.value"
                    :label="value.value"
                    >{{ value.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col v-if="user.userType === '00'" :span="8">
            <el-form-item label="商家账号：" class="item">
              <el-input
                v-model="form.pOperNo"
                class="input"
                size="small"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="平台渠道：" class="item">
                <el-select
                  clearable
                  v-model="form.platNo"
                  placeholder="请选择平台渠道"
                  class="input"
                  style="width: 100%"
                  size="small"
                >
                  <el-option
                    v-for="(value, index) in dictData['plat_no']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="来源国家：" class="item">
                <el-select
                  clearable
                  v-model="form.amazonSite"
                  placeholder="请选择来源国家"
                  class="input"
                  style="width: 100%"
                  size="small"
                >
                  <el-option
                    v-for="(value, index) in dictData['amazon_site']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="购买时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.payTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="ASIN：" class="item">
                <el-input
                  v-model="form.asin"
                  class="input"
                  size="small"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="订单编号：" class="item">
                <el-input
                  v-model="form.appNo"
                  class="input"
                  size="small"
                  clearable
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="user.userType == '00' ? 24 : 8">
            <div class="item right">
              <el-button type="primary" size="small" @click="getData(1)"
                >搜索</el-button
              >
              <el-button type="default" size="small" @click="reset"
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top">
        <div class="left">
          <el-button
            type="danger"
            size="small"
            @click="syncOrder"
            v-if="user.userType !== '00'"
          >
            同步订单
          </el-button>
          <div
            style="
              display: inline-block;
              font-weight: bold;
              color: red;
              font-size: 14px;
              margin: 0 0 0 16px;
            "
          >
            产品总额: {{ sumMoney }} 元
          </div>
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <el-table
        id="myOrder"
        ref="table"
        :data="tableData"
        class="table"
        :default-expand-all="true"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              ref="detailTable"
              class="table"
              border
              :data="[props.row]"
              :show-header="false"
            >
              <el-table-column width="340">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.skuList"
                      :key="index"
                    >
                      <div class="left">
                        <el-popover placement="bottom" trigger="hover">
                          <img
                            style="width: 320px; height: 320px"
                            :src="item.picUrl"
                          />
                          <img
                            class="mini-img"
                            :src="item.picUrl"
                            slot="reference"
                          />
                        </el-popover>
                      </div>
                      <div class="right">
                        <div
                          style="line-height: 15px; margin: 2px 0 0 0"
                          v-if="item.amazonProductName"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="`${item.amazonProductName}`"
                            placement="top-start"
                          >
                            <div
                              class="text-ellipsis"
                              style="display: inline-block; width: 219px"
                            >
                              <span> {{ item.amazonProductName }}</span>
                            </div></el-tooltip
                          >
                        </div>
                        <div :title="item.itemSku" class="text-ellipsis">
                          {{ item.itemSku }}
                        </div>
                        <div
                          style="
                            color: #409eff;
                            cursor: pointer;
                            line-height: 15px;
                            margin: 2px 0 0 0;
                          "
                          @click="handleOpenDetail(item)"
                          v-if="item.proName"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="`${item.proName}${
                              item.designId ? '（' + item.designId + '）' : ''
                            }`"
                            placement="top-start"
                          >
                            <div
                              class="text-ellipsis"
                              style="display: inline-block; width: 219px"
                            >
                              <span> {{ item.proName }}</span>
                              <span v-if="item.designId">
                                ({{ item.designId }})</span
                              >
                            </div></el-tooltip
                          >
                        </div>
                        <div
                          :title="item.properVal"
                          class="text-ellipsis"
                          v-if="item.properName"
                        >
                          <span v-if="item.properName && item.properVal">
                            <span
                              v-for="(i, ind) in [0, 1]"
                              :key="'i_' + ind"
                              style="margin-right: 10px"
                            >
                              {{ item.properName.split(":")[i] }}：
                              {{ item.properVal.split(":")[i] }}
                            </span>
                          </span>
                        </div>
                        <div
                          :title="`color: ${
                            item.color ? item.color : ''
                          } size: ${item.size ? item.size : ''}`"
                          class="text-ellipsis"
                        >
                          <span v-if="item.color"
                            >color: {{ item.color ? item.color : "" }}</span
                          >
                          <span v-if="item.size">
                            size: {{ item.size ? item.size : "" }}</span
                          >
                        </div>
                        <div>数量：{{ item.num || "-" }}</div>
                        <div>
                          <span v-if="item.salePrice" style="margin: 0 8px 0 0"
                            >{{ dictMap["currency_mark"][scope.row.currency]
                            }}{{ item.salePrice || "-" }}</span
                          >
                          <span v-if="item.proPrice"
                            >货款：{{ item.proPrice || "-" }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="160" align="center">
                <template slot-scope="scope">
                  <div class="loan-wrap">
                    <div>
                      <span class="title"> 产品金额 </span>
                      ：
                      {{ dictMap["currency_mark"][scope.row.currency] }}
                      {{ scope.row.saleTotal || "-" }}
                    </div>
                    <div>
                      <span class="title"> 运费 </span>
                      ：
                      {{ dictMap["currency_mark"][scope.row.currency] }}
                      {{ scope.row.saleFare || "-" }}
                    </div>
                    <div>
                      <span class="title"> 销售促销 </span>
                      ：
                      {{ dictMap["currency_mark"][scope.row.currency] }}
                      {{ scope.row.saleDiscount || "-" }}
                    </div>
                    <div>
                      <span class="title"> 总计 </span>
                      ：
                      {{ dictMap["currency_mark"][scope.row.currency] }}
                      {{ scope.row.saleActPay || "-" }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="160" align="center">
                <template slot-scope="scope">
                  <div class="loan-wrap">
                    {{ scope.row.skuList[0].ansi }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="160" align="center">
                <template slot-scope="scope">
                  <div class="loan-wrap">
                    <div>
                      {{ scope.row.addr.receName }} ({{ scope.row.addr.state }})
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template slot-scope="scope">
                  <div style="float: left">
                    <div v-if="user.userType == '00'" class="loan-wrap">
                      {{ scope.row.pOperNo }}
                    </div>
                    <div class="loan-wrap">
                      {{ scope.row.skuList[0].amazonOrderStatus }}
                    </div>

                    <div class="loan-wrap">
                      购买时间：{{ scope.row.orderTime }}
                    </div>
                    <div class="loan-wrap">
                      发货时间：{{ scope.row.sendTime }}
                    </div>
                  </div>
                  <div
                    @click="edit(scope.row)"
                    style="
                      float: right;
                      margin: 8px 32px 0 0;
                      cursor: pointer;
                      color: #409eff;
                    "
                  >
                    详情
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="产品信息" align="left" width="340">
          <template slot-scope="scope" style="cursor: pointer">
            <div>
              订单号：<span
                @click="edit(scope.row)"
                style="color: #409eff; cursor: pointer"
                >{{ scope.row.appNo }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="订单金额"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          label="ASIN"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          label="收件人"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column label="状态/时间" align="center"></el-table-column>
        <el-table-column label="" align="center">
          <template slot-scope="scope">
            <div
              style="
                text-align: right;
                padding: 0 16px 0 0;
                position: absolute;
                right: 24px;
                top: 12px;
                width: 300px;
              "
            >
              {{ dictMap["plat_no"][scope.row.platNo] || "" }}：{{
                scope.row.shopName
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>

    <!-- 编辑订单弹窗 -->
    <FbaOrderDetail
      v-if="currentAppId"
      :visible="showEdit"
      :appId="currentAppId"
      :orderData="currentOrder"
      @onClose="hideEdit"
    />

    <!-- 同步订单弹窗 -->
    <SyncOrder
    :platNo="`04`"
      :visible="showSyncOrder"
      @onClose="hideSyncOrder"
      @update="getData"
    />
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import FbaOrderDetail from "./components/FbaOrderDetail"
import { mapGetters } from "vuex"
import dayjs from "dayjs"
import { listFba, getFbaInfo } from "@/api/order/all"
import { getShopList } from "@/api/system/shopManage"
import SyncOrder from "./components/SyncOrder"

export default {
  name: "fbaOrder",
  components: {
    Breadcrumb,
    FbaOrderDetail,

    SyncOrder,
  },
  data() {
    return {
      form: {
        platNo: "", // 平台渠道
        amazonSite: "", // 来源国家
        payTime: [],
        shopId: [], // 店铺名称
        amazonOrderStatus: [], // 订单状态
        appNo: "", // 订单编号
        asin: "",
        pageNum: 1,
        pageSize: 10,
        pOperNo: "",
      },
      cancelOrderVisible: false, //取消订单弹框
      modalTitle: "",
      modalText: "",
      statusText: "",
      statusMap: null,
      total: 0,
      tableData: [], // 表格数据
      multipleSelection: [], // 选中列表数据
      showSyncOrder: false,
      showService: false,
      showExchange: false,
      showEdit: false,
      showRemark: false,
      showCopy: false,
      showEditSale: false,
      currentOrder: {},
      currentAppId: "",
      shopList: [],
      roles: [],
      sumMoney: 0,
      isCheckShop: true,
      isCheckStatus: true,
      shopName: "",
      isExpand: false,
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    ...mapGetters(["user"]),
  },
  mounted() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.form.payTime = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]
    this.getData()
    this.getShops()
    this.roles = this.user.roles
    //  this.dictData["amazon_order_status"].map((record) => {
    //   this.form.amazonOrderStatus.push(record.value)
    // })
  },
  methods: {
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
        //  this.handleChangeShop()
      })
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    handleChangeStatus() {
      this.form.amazonOrderStatus = []
      if (this.isCheckStatus) {
        this.dictData["amazon_order_status"].map((record) => {
          this.form.amazonOrderStatus.push(record.value)
        })
      }
    },
    // 搜索
    getData() {
      this.startLoading()
      let params = Object.assign({}, this.form)

      if (this.form.payTime && this.form.payTime.length > 0) {
        params["orderTimeBegin"] = dayjs(this.form.payTime[0]).format(
          "YYYY-MM-DD"
        )
        params["orderTimeEnd"] = dayjs(this.form.payTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      params.shopIds = params.shopId.join(",")
      params.amazonOrderStatus = params.amazonOrderStatus.join(",")

      if (params.shopIds == "" && this.isCheckShop) {
        let shopId = []
        for (let record of this.shopList) {
          shopId.push(record.shopId)
        }
        params.shopIds = shopId.join(",")
      }

      delete params["payTime"]
      delete params["shopId"]

      listFba(params)
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("获取订单列表失败")
          } else {
            this.total = res.total
            this.tableData = res.rows
            this.sumMoney = res.data.totalSaleActPay
          }
          this.endLoading()
        })
        .catch(() => [this.endLoading()])
    },
    // 重置
    reset() {
      this.form = {
        platNo: "", // 平台渠道
        amazonSite: "", // 来源国家
        payTime: [],
        shopId: [], // 店铺名称
        amazonOrderStatus: [], // 订单状态
        appNo: "", // 订单编号
        asin: "",
        pageNum: 1,
        pageSize: 10,
      }
    },
    syncOrder() {
      this.showSyncOrder = true
    },
    hideSyncOrder() {
      this.showSyncOrder = false
    },
    // 编辑订单
    edit(data) {
      getFbaInfo(data.appId).then((res) => {
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showEdit = true
      })
    },
    hideEdit() {
      this.showEdit = false
    },
    okEditSale() {
      this.getData()
      this.showEditSale = false
    },
    syncOrder() {
      this.showSyncOrder = true
    },
    hideSyncOrder() {
      this.showSyncOrder = false
    },
  },
}
</script>

<style scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {
  min-height: 42px;
}

.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body /deep/.el-table .cell {
  padding: 0;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 12px;
  width: 97px;
  height: 97px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
}

.table-info .left .mini-img {
  width: 95px;
  height: 95px;
}

.table-info .right {
  font-size: 12px;
  width: 200px;
  height: 123px;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: left;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.operate .link {
  font-size: 12px;
  color: #1e7ec8;
  cursor: pointer;
}

.table /deep/.el-table_1_column_1 {
  width: 0px !important;
  height: 0px !important;
}

.table /deep/.el-table_1_column_1 .cell {
  visibility: hidden !important;
  cursor: not-allowed !important;
}

.table /deep/.el-table__expanded-cell[class*="cell"] {
  padding: 8px 16px;
}
.table-body /deep/ .expanded {
  background: #f5f7fa;
}
.form-body .el-col-8 {
  margin: 0px 0 6px 0;
}
</style>
